var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-weight-light mb-3",class:[
    _vm.$vuetify.breakpoint.smAndDown ? 'text-subtitle-1' : 'title',
    _vm.dark ? 'text--lighten-4' : 'text--darken-3',
    _vm.$vuetify.theme.dark ? undefined : 'grey--text',
  ],style:(_vm.measurableStyles)},[_c('base-markdown',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }